/** @format */

import { EModelAuth, ENotification } from "types";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

type State = {
  openModalGlobal: boolean;
  loadingGlobal: boolean;
  openModalCreateCharacter: boolean;
  openModalAuth: EModelAuth;
  openModalExpireSession: boolean;
  isConfirmTerm: boolean;
  openModalWarn: ENotification;
  isShowSearch: boolean;
};

type Actions = {
  setOpenModalGlobal: (v: boolean) => void;
  setLoadingGlobal: (v: boolean) => void;
  setOpenModalCreateCharacter: (v: boolean) => void;
  setOpenModalAuth: (v: EModelAuth) => void;
  setOpenModalExpireSession: (v: boolean) => void;
  setIsConfirmTerm: (v: boolean) => void;
  setOpenModalWarn: (v: ENotification) => void;
  setIsShowSearch: (v: boolean) => void;
};

const initialState: State = {
  openModalGlobal: false,
  loadingGlobal: false,
  openModalCreateCharacter: false,
  openModalAuth: EModelAuth.DEFAULT,
  openModalExpireSession: false,
  isConfirmTerm: false,
  openModalWarn: ENotification.DEFAULT,
  isShowSearch: false,
};

export const useLayout = create<State & Actions>()(
  devtools(
    (set) => ({
      ...initialState,
      setOpenModalGlobal: (v) => set({ openModalGlobal: v }),
      setLoadingGlobal: (v) => set({ loadingGlobal: v }),
      setOpenModalCreateCharacter: (v) => set({ openModalCreateCharacter: v }),
      setOpenModalAuth: (v) => set({ openModalAuth: v }),
      setOpenModalExpireSession: (v) => set({ openModalExpireSession: v }),
      setIsConfirmTerm: (v) => set({ isConfirmTerm: v }),
      setOpenModalWarn: (v) => set({ openModalWarn: v }),
      setIsShowSearch: (v) => set({ isShowSearch: v }),
    }),
    {
      name: "LayoutStore",
    }
  )
);
